exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body{color:#fff;background-color:pink}.app{margin-top:20px;margin-bottom:20px;display:flex}.app .cities{width:30%}.app .active-city{width:70%;margin-left:20px;margin-bottom:20px;padding:10px 15px;border:1px solid #ddd;border-radius:4px}.app .active-city h3{margin-top:0}.list-group-item{background-color:transparent;cursor:pointer;list-style-type:none}", ""]);

// exports
